import { Component, Input, OnInit } from '@angular/core';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';

@Component({
  selector: 'app-success-message',
  templateUrl: './success-message.component.html',
  styleUrls: ['./success-message.component.scss'],
})
export class SuccessMessageComponent implements OnInit {

  // @Input() successMessageService : any = false;
  
  constructor(
    public successMessageService: SuccessMessageService,
  ){}

  ngOnInit() {}

  getMessage() {
    return this.successMessageService.getMessage();
  }
}
